<div class="form-group {{ extraFormClass }}">
  <label [for]="inputId" *ngIf="!suppressLabel" [ngClass]="{ 'font-weight-bold': labelBold }">
    {{ translateTag | translate: translateParams }}
    <i *ngIf="tooltip" class="{{ tooltipClass }}" ngbTooltip="{{ tooltip | translate }}"></i>
    <span *ngIf="footnote" class="ml-1">*</span>
  </label>
  <div class="color-input-wrapper">
    <input
      type="text"
      [class]="extraInputClass"
      [ngClass]="{
        'form-control-plaintext': renderStatic,
        'form-control': !renderStatic,
        'color-text-input': !renderStatic,
        'is-invalid': invalidColor
      }"
      [readonly]="renderStatic"
      [id]="inputId"
      [name]="inputId"
      [required]="required"
      [disabled]="disabled"
      [placeholder]="placeholder | translate"
      [value]="value || ''"
      (input)="onTextChange($event)"
      (blur)="onTouched()"
    />
    <div 
      class="color-preview" 
      [class.disabled]="disabled || renderStatic"
      [class.invalid]="invalidColor"
      [style.background-color]="value || '#ffffff'"
      (click)="openColorPicker()"
      [ngbTooltip]="'CLICK_TO_PICK_COLOR' | translate"
    >
      <i class="fas fa-eyedropper"></i>
    </div>
    <input 
      #colorPicker
      type="color" 
      [disabled]="disabled"
      [value]="value || '#ffffff'"
      (input)="onColorChange($event)"
      (blur)="onTouched()"
      class="hidden-color-picker"
    />
  </div>
  <small class="text-danger" *ngIf="invalidColor" translate>INVALID_COLOR_FORMAT</small>
</div>
